import { getRequestHeadersProclaim } from '~/common/helpers.js'
import { createBaseService } from '~/services/base.axios.service.js'

const service = createBaseService(getRequestHeadersProclaim, import.meta.env.VITE_PROCLAIM_API_BASE || '')

export default service
